import { legacy_createStore, compose, applyMiddleware, bindActionCreators } from 'redux';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import thunk from 'redux-thunk';

import { rootReducer } from './rootReducer';
import { iReduxState } from '../interfaces/interfaces';
import { showRedux } from '../settings';

import * as appActionCreators from './app/appActions';
import * as chromiaActionCreators from './chromia/chromiaActions';
import * as basicActionCreators from './basic/basicActions';
import * as proActionCreators from './pro/proActions';
import * as modalActionCreators from './modals/modalsActions';
import * as UIActionCreators from './UI/UIActions';

declare global{
	interface Window{
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : any;
	}
}

const composeEnhancers = (showRedux && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose ;

export const store = legacy_createStore(rootReducer, composeEnhancers(
	applyMiddleware(thunk)
));

export type tDispatch = typeof store.dispatch;

export const useStoreDispatch = () => {		// combine all actions and wrapps it in dispatch
	const allActionCreators = {
		...appActionCreators,
		...chromiaActionCreators,
		...proActionCreators,
		...basicActionCreators,
		...modalActionCreators,
		...UIActionCreators,
	};
	return bindActionCreators(allActionCreators, useDispatch());
}

export const useStoreSelector: TypedUseSelectorHook<iReduxState> = useSelector;	// gives access to redux store